<template>
    <div class="filter__wrap">
        <div class="filter__field filter__field--check">
            <span class="filter__select-label">{{ $t('general.select-label') }}</span>
            <v-checkbox :label="$t('general.select-all')" v-model="selectAllChecked" @click="$emit('selected-all', selectAllChecked)" hide-details dense class="mt-0 pt-0"></v-checkbox>
            <v-checkbox :label="$t('general.select-new')" v-model="selectNewChecked" @click="$emit('selected-new', selectNewChecked)" hide-details dense class="mt-0 pt-0"></v-checkbox>
        </div>
        <v-btn
            small
            color="primary"
            @click="$emit('on-choose-today')"
            class="elevation-1">
            {{ $t('general.today') }}
        </v-btn>
        <v-btn
            small
            color="primary"
            @click="$emit('on-choose-yesterday')"
            class="elevation-1">
            {{ $t('general.yesterday') }}
        </v-btn>
        <v-btn
            small
            color="primary"
            @click="$emit('on-choose-weekly')"
            class="elevation-1">
            {{ $t('general.weekly') }}
        </v-btn>
        <div class="filter__export">
        <download-excel
            :data="selected"
            :fields="excelFields"
            :name="todayDate"
        >
            <v-btn
                small
                color="primary"
                :disabled="selected.length < 1"
                class="elevation-1">
                <v-icon left small>mdi-download</v-icon>
                {{ $t('general.excel-export') }}
            </v-btn>
        </download-excel>
        <v-btn
            small
            color="primary"
            @click="onSelectedMode"
            :disabled="isBlockBtnPrint"
            :loading="loading_print_items"
            class="elevation-1">
            <v-icon left small>{{ actionIcons[selectedItem] }}</v-icon>
            {{ $t(`general.${this.selectedItem.toLowerCase()}-labels`) }}
        </v-btn>
        </div>
        <div class="filter__field filter__field--actions">
            <v-select
                :label="$t('general.actions')"
                v-model="selectedItem"
                :items="['Print', 'Delete', 'Mail']"
                dense
                hide-details
            >
                <template v-slot:selection="{ item }">
                    <v-icon small class="mr-2">{{ actionIcons[item] }}</v-icon>{{ item }}
                </template>
                <template v-slot:item="{ item }">
                    <v-icon small class="mr-2">{{ actionIcons[item] }}</v-icon>{{ item }}
                </template>
            </v-select>
        </div>
        <v-dialog v-model="dialogDeleteSelectedItems" max-width="500px">
            <v-card>
                <v-card-title class="text-h5">{{ $t('general.are-you-sure-you-want-items') }}</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="closeDeleteSelectedItems"
                    >{{ $t('general.cancel') }}
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteSelectedItemsConfirm"
                    >{{ $t('general.ok') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
//import Order from "../../../models/Order";

import {mapActions} from "vuex";

export default {
    name: "OrderFilter",
    props: ['selected', 'loading_print_items'],
    components: {},
    data: () => ({
        selectAllChecked: false,
        selectNewChecked: false,
        selectedItem: 'Print',
        actionIcons: {Print: 'mdi-printer', Delete: 'mdi-delete', Mail: 'mdi-email-outline'},
        dialogDeleteSelectedItems: false,
        excelFields: {
            "Name": "name",
            "Date": "date",
            "Address": "delivery.address",
            "Zip": "delivery.zip",
            "Vat number": "delivery.vat_number",
            "Info": "delivery.info",
            "Phone": "phone",
            "Email": "email",
            "Details": "details",
            "Payment method": "payment_method",
            "Time": "time",
            "Status": "status",
            "Amount": "amount",
            "Token": "token",
            "Delivery type": "delivery_type",
            "Created": "created_at",
            "Delivery cost": "delivery_cost",
        },
        todayDate: `${new Date().toString()}.xls`
    }),
    computed: {
        isBlockBtnPrint() {
            return !this.selected.length
        },
    },
    methods: {
        ...mapActions(["destroyOrder"]),
        onSelectedMode() {
          this.selectedItem === "Print" ? this.onPrintItems() : this.selectedItem === "Delete" ? this.onDeleteItems() : this.onMailItems()
        },
        onDeleteItems() {
            this.dialogDeleteSelectedItems = true
        },
        closeDeleteSelectedItems() {
            this.dialogDeleteSelectedItems = false;
        },
        async deleteSelectedItemsConfirm() {
            this.selected.map((item) => {
               this.destroyOrder(item);
            })
            await this.$emit('init-items')
            this.closeDeleteSelectedItems()
        },
        onPrintItems() {
            this.$emit('print-labels', this.selected)
        },
        onMailItems() {
            this.$emit('mail-labels', this.selected)
        },
    },
}
</script>

<style scoped lang="scss">

.filter__wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;

    .filter__field {
        background: #fff;
        padding: 11px 10px;
        border-radius: 5px;
        max-height: 65px;
    }

    // same height as the (small) buttons, labels on one line
    .filter__field--check {
        display: flex;
        align-items: center;
        gap: 12px;
        height: 28px;
        padding: 0 12px;
        white-space: nowrap;
    }

    .filter__select-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
    }

    .filter__export {
        display: flex;
        gap: 12px;
    }

    // keeps the actions dropdown at the right end, as before;
    // enough top padding for the floating "Actie" label
    .filter__field--actions {
        margin-left: auto;
        width: 160px;
        padding: 14px 10px 6px;
    }

    // too narrow for one row (needs ~1400px): Actie stays top right,
    // Excel + labels move to a second row
    @media (max-width: 1439px) {
        .filter__field--actions {
            order: 1;
        }

        .filter__export {
            order: 2;
            flex-basis: 100%;
        }
    }
}


</style>
